// Initializes the buttons with data attributes and sets up event listeners.
const setupAQSButtons = () => {
  // Get all the buttons with data attributes that haven't been updated yet
  const aqsButtons = document.querySelectorAll('[data-aqs][data-box]:not([data-aqsran])');

  // Capture each card's Tune URL before any same-slug href rewriting.
  // A shared `.aqs_tune[data-provider]` lookup reused the first card's link
  // when multiple cards share a provider slug (WE-967 / WE-968).
  // Persist on data-aqs-tune so later clones (e.g. geo compare) still have
  // the real partner link after href was set to javascript:;.
  const cardTuneUrls = new Map();
  aqsButtons.forEach((button) => {
    if (!button.dataset.aqsTune) {
      // Prefer CTAM-specific Tune (data-ctam-link) when present; otherwise the CTA href.
      button.dataset.aqsTune =
        button.dataset.ctamLink || button.getAttribute('href') || '';
    }
    cardTuneUrls.set(button, button.dataset.aqsTune);
  });

  aqsButtons.forEach((button) => {
    const aqsBrand = button.dataset.name;
    const aqsSlug = button.dataset.slug;
    const aqsType = button.dataset.aqs;
    const aqsTech = button.dataset.localfibertype ?? '';
    const cardType = button.dataset.type ?? 'Residential';
    const userType = button.getAttribute('data-service-user-type-context') ?? 'Residential';
    const lsData = localStorage.getItem('mapi');
    const mapiRequestId = JSON.parse(lsData).requestId;
    const aqsCTA = button.dataset.aqsCta ?? (window.location.href.includes('/es') ? 'Verifica' : 'Verify');
    const cardTuneUrl = cardTuneUrls.get(button) || '';

    // change all links to javascript:; if they have the same slug so they trigger the lightbox
    document.querySelectorAll(`a[data-slug="${aqsSlug}"][data-aqs]`).forEach((el) => {
      el.href = 'javascript:;';
    });

    button.dataset.aqsran = true;

    // Adjusts the lightbox values when the button is clicked.
    button.addEventListener('click', function () {
      if (aqsType == 'localfiber' || aqsType == 'noqual') {
        document.querySelector('.aqs-or-get').classList.add('hidden');
      } else {
        document.querySelector('.aqs-or-get').classList.remove('hidden');
      }

      // Sets the value of .aqs_provider_name to aqsBrand.
      document.querySelectorAll('.aqs_qual .aqs_provider_name').forEach(
        (el) => {
          el.innerHTML = aqsBrand;
          });
        
          document.querySelector('.aqs_form button').innerHTML = aqsCTA;
        
      // Sets the values of hidden inputs in the form.
      // Use this card's captured Tune URL — not a shared per-slug element.
      // provider = brand (CTAM / mso_name); provider_slug = Sandstone slug (LocalFiber).
      document.querySelector('.aqs_form input[name="provider"]').value = aqsBrand;
      document.querySelector('.aqs_form input[name="provider_slug"]').value = aqsSlug;
      document.querySelector('.aqs_form input[name="aqs_tune"]').value = cardTuneUrl;
      document.querySelector('.aqs_form input[name="aqs_type"]').value = aqsType;
      document.querySelector('.aqs_form input[name="aqs_tech"]').value = aqsTech;
      document.querySelector('.aqs_form input[name="user_type"]').value = userType;
      document.querySelector('.aqs_form input[name="mapi_session_id"]').value = mapiRequestId;
    });
  });
}

export default setupAQSButtons;
